class CarouselReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.carousel = this.querySelector('[data-carousel]');
    this.controls = this.querySelectorAll('[data-prev], [data-next]');

    if (!this.carousel) return;

    this.flickity = new Flickity(this.carousel, {
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      freeScroll: true,
    });
    this.flickity.on('change', () => {
      window.pauseAllMedia();
    });
    this.controls.forEach((control) =>
      control.addEventListener('click', this.onControlClick.bind(this)),
    );
  }

  onControlClick(event) {
    const isNext = event.target.hasAttribute('data-next');

    if (!this.carousel) return;

    this.flickity[isNext ? 'next' : 'previous']();
  }
}

customElements.define('carousel-reviews', CarouselReviews);
